import React, { Component } from 'react';
import T from 'prop-types';
// components
import Button from '../../components/Button/Button';
import PersonalColor from './components/PersonalColor';
import PersonalInfoForm from './components/PersonalInfoForm';
import SupportPersonForm from './components/SupportPersonForm';
// shapes
import userShape from '../../shapes/user';
// styles
import styles from './UserProfile.mod.css';

class UserProfileClient extends Component {
  render() {
    const {
      user,
      updateUser,
      deleteAccount,
      changePassword,
      deleteUserSupport,
    } = this.props;
    const userColor = user.profile_color || '#33C370';

    return (
      <div className="row">
        <div className="col-sm-4 col-xs-12">
          <br />
          <PersonalColor user={user} updateUser={updateUser} />
        </div>
        <div className="col-sm-8 col-xs-12">
          <h3>Personal Information</h3>
          <PersonalInfoForm
            user={user}
            onSubmit={updateUser}
            color={userColor}
          />
          <br />

          <h3>Support Person</h3>
          <SupportPersonForm
            isZero={user.progress.module === 0}
            supportPerson={user.support_person}
            deleteUserSupport={deleteUserSupport}
            color={userColor}
          />
          <br />

          <h3>Change Password</h3>
          <p className={styles.text}>
            You can change your password here. <br />
            Note: using stronger password gains more safety on your account.
          </p>
          <Button onClick={changePassword} color={userColor}>
            Change
          </Button>
          <br />
          <br />

          <h3>Delete Account</h3>
          <p className={styles.text}>
            You can end your subscription and delete your Ladder account any
            time. All your information will be permanently deleted.
          </p>
          <Button onClick={deleteAccount}>Delete</Button>
        </div>
      </div>
    );
  }
}

UserProfileClient.propTypes = {
  user: userShape,
  deleteAccount: T.func.isRequired,
  updateUser: T.func.isRequired,
  deleteUserSupport: T.func.isRequired,
};

export default UserProfileClient;



// WEBPACK FOOTER //
// ./src/containers/UserProfile/UserProfileClient.jsx